<app-admin-header [showBreadCrums]="false"></app-admin-header>
<p-messages [(value)]="messages" [enableService]="false"></p-messages>
<div class="container-fluid v4-bg-img">
<div class="container grey-box">
  <app-user-table
    [data]="survey?.attendance || []"
    [loading]="loading"
    [messages]="messages"
    [columns]="[
      'the name',
      'E-mail',
      'Contact',
      'Gender',
      'Status',
      'Mark Type',
      'Marked At'
    ]"
    [action]="1"
    [goBackBtn]="true"
    [pagging]="false"
    [totalCount]="0"
    (actionClicked)="confirmMark($event)"
  ></app-user-table>
</div>
</div>
<p-confirmDialog [style]="{ margin: '0rem 1rem' }"></p-confirmDialog>
<app-footer></app-footer>
